<template>
  <div class="entering-wrapper">
    <entering-step :step="step" stepOneText="个人信息" stepTwoText="认证信息" />
    <!-- 第一部分 -->
    <div class="form-wrapper">
      <div class="form-item vertical">
        <div class="form-type"><span class="required">上传身份证照片</span></div>
        <div class="form-content upload-box">
          <div class="upload-item" id="uploadIDBack" @click="wxUploader('idBack')">
            <div class="upload-placeholder" v-if="!idBackPreview">
              <icon icon-class="upload" />
              <p>上传人像页</p>
            </div>
            <div class="preview-box" v-else>
              <img :src="idBackPreview">
              <div class="upload-status" :class="{'done': idBackFile.status == 5}" v-if="idBackFile && idBackFile.status">{{idBackFile.status | uploadStatus}}</div>
            </div>
          </div>
          <div class="upload-item" id="uploadIDFront" @click="wxUploader('idFront')">
            <div class="upload-placeholder" v-if="!idFrontPreview">
              <icon icon-class="upload" />
              <p>上传国徽页</p>
            </div>
            <div class="preview-box" v-else>
              <img :src="idFrontPreview">
              <div class="upload-status" :class="{'done': idFrontFile.status == 5}" v-if="idFrontFile && idFrontFile.status">{{idFrontFile.status | uploadStatus}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-item vertical">
        <div class="form-type"><span class="required">上传手写签章</span></div>
        <div class="form-content upload-box">
          <div class="upload-item" id="signWrapper" @click="initSignPad">
            <div class="upload-placeholder" v-if="!signBase64">
              <icon icon-class="upload" />
              <p>上传手写签章</p>
            </div>
            <div class="preview-box" v-else>
              <img :src="signBase64">
              <div class="upload-status done">签章成功</div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-item vertical">
        <div class="form-type"><span>上传执业医师<span style="color:#EE0A24">资格证书</span>照片</span></div>
        <div class="form-content upload-box">
          <div class="upload-item" id="uploadLicense" @click="wxUploader('license')">
            <div class="upload-placeholder" v-if="!licensePreview">
              <icon icon-class="upload" />
              <p>上传证书第一页</p>
            </div>
            <div class="preview-box" v-else>
              <img :src="licensePreview">
              <div class="upload-status" :class="{'done': licenseFile.status == 5}" v-if="licenseFile && licenseFile.status">{{licenseFile.status | uploadStatus}}</div>
            </div>
          </div>
          <div class="upload-item" id="uploadLicense2" @click="wxUploader('license2')">
            <div class="upload-placeholder" v-if="!license2Preview">
              <icon icon-class="upload" />
              <p>上传证书第二页</p>
            </div>
            <div class="preview-box" v-else>
              <img :src="license2Preview">
              <div class="upload-status" :class="{'done': license2File.status == 5}" v-if="license2File && license2File.status">{{license2File.status | uploadStatus}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-item vertical">
        <div class="form-type"><span>医师<span style="color:#EE0A24">资格证书</span>编号</span></div>
        <div class="form-content">
          <input type="text" class="form-input" v-ios-bug-fixed placeholder="请输入医师资格证书编号" v-model="certNumber" />
        </div>
      </div>

      <!--新增执业证书相关片段-->
      <div class="form-item vertical">
        <div class="form-type"><span>上传执业医师<span style="color:#EE0A24">执业证书</span>照片</span></div>
        <div class="form-content upload-box">
          <div class="upload-item" id="uploadPrac" @click="wxUploader('prac')">
            <div class="upload-placeholder" v-if="!pracPreview">
              <icon icon-class="upload" />
              <p>上传证书第一页</p>
            </div>
            <div class="preview-box" v-else>
              <img :src="pracPreview">
              <div class="upload-status" :class="{'done': pracFile.status == 5}" v-if="pracFile && pracFile.status">{{pracFile.status | uploadStatus}}</div>
            </div>
          </div>
          <div class="upload-item" id="uploadPrac2" @click="wxUploader('prac2')">
            <div class="upload-placeholder" v-if="!prac2Preview">
              <icon icon-class="upload" />
              <p>上传证书第二页</p>
            </div>
            <div class="preview-box" v-else>
              <img :src="prac2Preview">
              <div class="upload-status" :class="{'done': prac2File.status == 5}" v-if="prac2File && prac2File.status">{{prac2File.status | uploadStatus}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-item vertical">
        <div class="form-type"><span>医师<span style="color:#EE0A24">执业证书</span>编号</span></div>
        <div class="form-content">
          <input type="text" class="form-input" v-ios-bug-fixed placeholder="请输入医师执业证书编号" v-model="pracNumber" />
        </div>
      </div>
      <!--结束-->
      <div class="form-item vertical">
        <div class="form-type"><span>上传职称证书照片</span></div>
        <div class="form-content upload-box">
          <div class="upload-item" id="uploadJobPaper" @click="wxUploader('jobTitle')">
            <div class="upload-placeholder" v-if="!jobTitlePreview">
              <icon icon-class="upload" />
              <p>上传证书</p>
            </div>
            <div class="preview-box" v-else>
              <img :src="jobTitlePreview">
              <div class="upload-status" :class="{'done': jobTitleFile.status == 5}" v-if="jobTitleFile && jobTitleFile.status">{{jobTitleFile.status | uploadStatus}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-item vertical">
        <div class="form-type"><span>职称证书编号</span></div>
        <div class="form-content">
          <input type="text" class="form-input" v-ios-bug-fixed placeholder="请输入职称证书编号" v-model="titleNumber" />
        </div>
      </div>
    </div>
    <div class="submit-box">
      <div class="agreement" v-if="agreement">
        <icon icon-class="cricle-success" class="checked" />
        我已阅读并同意<a href="javascript:;" @click.stop="agreementShow = true">《医生入驻协议》</a>
      </div>
      <button class="submit-button" :disabled="submitting" @click="submit">{{agreement ? '提交认证' : '阅读 《医生入驻协议》'}}</button>
    </div>

    <!-- 协议 -->
    <van-popup v-model="agreementShow" position="bottom" :style="{height: '100%'}">
      <div class="popup-wrapper">
        <div class="popup-header">
          《医生入驻协议》
          <span class="close-popup" @click="agreementShow = false">关闭</span>
        </div>
        <div class="agreement-dialog-wrapper" @scroll="agreementScrollHandler">
          <div class="agreement-tips">需要阅读完毕才可以同意本协议</div>
          <agreement />
        </div>
        <div class="fixed-agree"><button class="agree-button" :disabled="!agreementReaded" @click="agreementHandler">同意</button></div>
      </div>
    </van-popup>
    <!-- 签章手写板 -->
    <van-popup v-model="signPadShow" position="bottom" :style="{height: '100%'}">
      <div class="popup-wrapper">
        <div class="popup-header">
          上传手写签章
          <span class="close-popup" @click="signPadShow = false">取消</span>
        </div>
        <div class="sign-wrapper">
          <div class="sign-box" ref="signBox">
            <p class="sign-tips">
              <icon icon-class="edit"></icon>请确保书写清晰规范
            </p>
            <canvas id="signaturePad"></canvas>
          </div>
        </div>
        <div class="sign-control">
          <button class="sign-button clear" @click="clearSignPad">清空</button>
          <button class="sign-button save" @click="saveSign">保存签章</button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<style lang="less" scoped>
  .entering-wrapper{
    background: #F7F7F7;
  }
  .form-wrapper{
    padding: 36px 0;
    margin-top: 12px;
    background: #FFF;
    .form-item{
      position: relative;
      padding: 0 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #FFF;
      height: 40px;
      margin-bottom: 16px;
      transition: all .1s;
      &.vertical{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        height: auto;
        margin-bottom: 40px;
        &:last-child{
          margin-bottom: 0;
        }
        .form-content{
          position: relative;
          width: 100%;
          margin-top: 16px;
          .form-input{
            width: 100%;
            height: 44px;
            background: #F7F7F7;
            padding: 0 12px;
            font-size: 14px;
            color: @black;
            border-radius: 4px;
          }
        }
      }
      &.error{
        margin-bottom: 28px;
        .form-content .form-text{
          color: @error;
        }
      }
      .form-type{
        font-size: 16px;
        color: #666;
        font-weight: bold;
        .required{
          position: relative;
          &::after{
            content: '*';
            position: absolute;
            left: 100%;
            top: 0;
            margin-left: 2px;
            font-size: 16px;
            color: @error;
          }
        }
        .tips{
          margin-top: 6px;
          font-size: 12px;
          color: @xile;
        }
      }
      .form-content{
        color: #666;
        font-size: 16px;
        &.upload-box{
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          padding-left: 8px;
          .upload-item{
            // width: 156px;
            flex: 1;
            max-width: 156px;
            height: 100px;
            overflow: hidden;
            margin-right: 15px;
            &:last-child{
              margin-right: 0;
            }
            .upload-placeholder{
              cursor: pointer;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              // width: 156px;
              width: 100%;
              height: 100px;
              background: #F3F3F3;
              border: 1px dashed #CCC;
              border-radius: 4px;
              text-align: center;
              color: #CCC;
              font-size: 12px;
              svg{
                font-size: 32px;
              }
              p{
                margin-top: 12px;
              }
            }
            .preview-box{
              position: relative;
              cursor: pointer;
              display: flex;
              justify-content: center;
              align-items: center;
              // width: 156px;
              width: 100%;
              height: 100px;
              border-radius: 4px;
              overflow: hidden;
              border: 1px dashed #CCC;
              img{
                width: 156px;
              }
              .upload-status{
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                height: 24px;
                color: #FFF;
                font-size: 12px;
                line-height: 24px;
                text-align: center;
                background: rgba(0, 0, 0, .4);
                transition: all .2s;
                &.done{
                  background: @xile;
                }
              }
            }
          }
        }
      }
      .license-number-typer{
        margin: 24px 8px 0;
        width: calc(100% - 16px);
        .number-type{
          font-size: 14px;
          color: #666;
          font-weight: bold;
          white-space: nowrap;
          margin-bottom: 8px;
        }
        .number-input{
          background: #F7F7F7;
          border-radius: 4px;
          height: 44px;
          width: 100%;
          padding: 0 12px;
          overflow: hidden;
          input{
            width: 100%;
            font-size: 14px;
            line-height: 20px;
            padding: 12px 0;
            color: #333;
            background: #F7F7F7;
          }
        }
      }
      .form-error{
        position: absolute;
        right: 16px;
        top: 100%;
        font-size: 12px;
        color: @error;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .van-icon{
          position: relative;
          top: 1px;
          width: 12px;
          height: 12px;
          background: @error;
          color: #FFF;
          border-radius: 50%;
          margin-right: 4px;
        }
      }
    }
  }
  .submit-box{
    padding: 24px 16px 12px;
    .agreement{
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 12px;
      font-size: 14px;
      color: #666;
      svg{
        font-size: 14px;
        margin-right: 4px;
        color: #CCC;
      }
      svg.checked{
        color: @xile;
      }
      a{
        color: @xile;
      }
    }
    .submit-button{
      @button-base();
      width: 100%;
      height: 40px;
      font-size: 14px;
    }
  }
  .popup-wrapper{
    position: relative;
    width: 100%;
    height: 100%;
    background: #FFF;
    .popup-header{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 15px;
      font-weight: bold;
      background: #F3F3F3;
      z-index: 100;
      .close-popup{
        position: absolute;
        top: 50%;
        right: 16px;
        transform: translateY(-50%);
        font-size: 13px;
        color: @black;
        font-weight: normal;
        background: transparent;
        border: 0;
      }
    }
    .agreement-dialog-wrapper{
      margin-top: 0;
      padding-top: 48px;
      height: calc(100%);
      background: #FAFAFA;
      overflow-y: auto;
      -webkit-overflow-scroll: touch;
      padding-bottom: 64px;
      .agreement-tips{
        width: 100%;
        height: 24px;
        line-height: 24px;
        text-align: center;
        background: @xile;
        color: #FFF;
        font-size: 13px;
      }
    }
    .fixed-agree{
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 12px 16px;
      background: #FFF;
      box-shadow: 0 -2px 6px 0 rgba(0,0,0,.04);
      .agree-button{
        @button-base();
        height: 40px;
        width: 100%;
        &:disabled{
          background: #CCC;
          color: #666;
        }
      }
    }
    .sign-wrapper{
      padding: 68px 25px 0;
      height: calc(100%);
      background: #F7F7F7;
      .sign-box{
        background: #FFF;
        border: 1px dashed #CCC;
        border-radius: 4px;
        max-width: 350px;
        margin: 0 auto;
        .sign-tips{
          margin-top: 17px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #999;
          font-size: 14px;
          line-height: 14px;
          svg{
            margin-right: 8px;
            font-size: 16px;
          }
        }
        #signaturePad{
          width: 100%;
          height: 400px;
        }
      }
    }
    .sign-control{
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .sign-button{
        @button-base();
        width: 50%;
        height: 48px;
        border-radius: 0;
        font-weight: normal;
        &.clear{
          background: #F3F3F3;
          color: #333;
        }
      }
    }
  }
</style>

<script type="text/javascript">
  import enteringStep from '@/components/Common/enteringStep'
  import agreement from '@/components/Agreement/doctorAgreement'
  import SignaturePad from 'signature_pad'
  export default {
    data() {
      return {
        step: 2,
        agreement: true, //暂时修改为true 正常运营使用
        submitting: false,
        // 图片上传实例
        //身份证人像
        idBackUploader: null,
        idBackPreview: '',
        idBackFile: {},
        //身份证国徽
        idFrontUploader: null,
        idFrontPreview: '',
        idFrontFile: {},
        //资格证书
        licenseUploader: null,
        licensePreview: '',
        licenseFile: {},

        license2Uploader: null,
        license2Preview: '',
        license2File: {},
        //执业证书
        pracUploader: null,
        pracPreview: '',
        pracFile: {},

        prac2Uploader: null,
        prac2Preview: '',
        prac2File: {},
        //职称证书
        jobTitleUploader: null,
        jobTitlePreview: '',
        jobTitleFile: {},
        // 证书编号
        certNumber: '',
        titleNumber: '',
        pracNumber: '',
        // 签名base64字符串
        signBase64: '',

        // 入驻协议弹窗
        agreementShow: false,
        // 是否阅读完毕
        agreementReaded: false,
        // 签名板弹窗
        signPadShow: false,
        signPadCanvas: null,
      }
    },
    created() {
      let _this = this;

      let url = encodeURIComponent(window.location.href.split('#')[0])
      this.$root.post('/getJsSdk', {
        // url: `${window.location.protocol}//${window.location.host}/`
        url: url
      }).then(data => {
        if (data) {
          wx.config({
            debug: this.$store.state.wechatDebug,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ['chooseImage', 'uploadImage']
          });
          wx.checkJsApi({
            jsApiList: ['chooseImage', 'uploadImage'],
            success: function(res) {
              console.log(res)

            }
          });
        }
      })

      if (this.userInfo.doc_status != 1) {
        this.$router.forward();
      }
    },
    mounted() {
      /*
      this.setUpload(this.idBackUploader, 'uploadIDBack', 'idBackFile', 'idBackPreview');
      this.setUpload(this.idFrontUploader, 'uploadIDFront', 'idFrontFile', 'idFrontPreview');
      this.setUpload(this.licenseUploader, 'uploadLicense', 'licenseFile', 'licensePreview');
      this.setUpload(this.licenseSecondUploader, 'uploadLicenseSecond', 'licenseSecondFile', 'licenseSecondPreview');
      this.setUpload(this.docLicenseUploader, 'uploadDocLicense', 'docLicenseFile', 'docLicensePreview');
      this.setUpload(this.docLicenseSecondUploader, 'uploadDocSecondLicense', 'docLicenseSecondFile', 'docLicenseSecondPreview');
      this.setUpload(this.jobTitleUploader, 'uploadJobPaper', 'jobTitleFile', 'jobTitlePreview');
      */
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    components: {
      enteringStep,
      agreement
    },
    methods: {
      wxUploader(fileObj) {
        let _this = this;
        wx.chooseImage({
          count: 1, // 默认9
          sizeType: ['compressed'],
          sourceType: ['album', 'camera'],
          success: function(res) {
            var localIds = res.localIds;
            var localID = localIds[0].toString();
            switch (fileObj) {
              case "idBack":
                _this.idBackPreview = localID;
                _this.idBackFile.status = 1;
                break;
              case "idFront":
                _this.idFrontPreview = localID;
                _this.idFrontFile.status = 1;
                break;
              case "license":
                _this.licensePreview = localID;
                _this.licenseFile.status = 1;
                break;
              case "license2":
                _this.license2Preview = localID;
                _this.license2File.status = 1;
                break;
              case "jobTitle":
                _this.jobTitlePreview = localID;
                _this.jobTitleFile.status = 1;
                break;
              case "prac":
                _this.pracPreview = localID;
                _this.pracFile.status = 1;
                break;
              case "prac2":
                _this.prac2Preview = localID;
                _this.prac2File.status = 1;
                break;
            }

            wx.uploadImage({
              localId: localID,
              isShowProgressTips: 0,
              success: function(res) {
                var serverId = res.serverId;
                _this.$root.post('/getWxImg', {
                  id: serverId,
                  oss_dir: 'doctor',
                  filename: _this.$root.randomString(),
                  type: 1
                }).then(data => {
                  if (data.status == 1) {
                    switch (fileObj) {
                      case "idBack":
                        _this.idBackPreview = data.url;
                        _this.idBackFile.status = 5;
                        _this.idBackFile.path = data.url;
                        break;
                      case "idFront":
                        _this.idFrontPreview = data.url;
                        _this.idFrontFile.status = 5;
                        _this.idFrontFile.path = data.url;
                        break;
                      case "license":
                        _this.licensePreview = data.url;
                        _this.licenseFile.status = 5;
                        _this.licenseFile.path = data.url;
                        break;
                      case "license2":
                        _this.license2Preview = data.url;
                        _this.license2File.status = 5;
                        _this.license2File.path = data.url;
                        break;
                      case "jobTitle":
                        _this.jobTitlePreview = data.url;
                        _this.jobTitleFile.status = 5;
                        _this.jobTitleFile.path = data.url;
                        break;
                      case "prac":
                        _this.pracPreview = data.url;
                        _this.pracFile.status = 5;
                        _this.pracFile.path = data.url;
                        break;
                      case "prac2":
                        _this.prac2Preview = data.url;
                        _this.prac2File.status = 5;
                        _this.prac2File.path = data.url;
                        break;
                    }
                    /*
                    _this.$notify({
                      background: '#00848A',
                      message: '头像上传成功'
                    });
                    */
                  } else {
                    _this.$notify('发送图片失败');
                  }
                })


              },
              fail(err) {
                console.log('error');
                _this.$toast.clear();
                _this.$notify(`上传图片报错${JSON.stringify(err)}`);
              }
            });
          }
        });

      },
      // 上传单张函数
      setUpload(obj, id, file, preview) {
        let _this = this;
        obj = new plupload.Uploader({
          runtimes: 'html5,flash,silverlight,html4',
          browse_button: id,
          flash_swf_url: '/view/index/template/src/assets/js/plupload/js/Moxie.swf',
          silverlight_xap_url: '/view/index/template/src/assets/js/plupload/js/Moxie.xap',
          url: 'http://oss.aliyuncs.com',
          // 不检测重复文件
          filters: {
            // mime_types: [
            //   {title: "image", extensions: "jpg,jpeg,webp,png,bmp"}
            // ],
            // prevent_duplicates: true,
          },
          // 单文件上传
          multi_selection: false,
          init: {
            // 选择文件之后
            FilesAdded(up, files) {
              console.log(files);
              files.forEach(item => {
                let fileName = item.name;
                _this.$root.previewUploadImage(item, (imgSrc) => {
                  _this[preview] = imgSrc;
                })
              })
              _this[file] = files[0];
              _this.$root.setUploadParam(up, '', false);
              console.log(_this[file])
            },
            // 上传前设置文件名
            BeforeUpload(up, fileObj) {
              _this.$root.setUploadParam(up, fileObj.name, true);
            },
            // 上传完成
            FileUploaded(up, fileObj, info) {
              if (info.status == 200) {
                let res = JSON.parse(info.response);
                _this[file].path = res.path
                // _this.avatar = res.path;
              }
            },
            Error(up, err) {
              console.log(err);
            }
          }
        })
        // 初始化上传
        obj.init();
      },
      agreementHandler() {
        this.agreement = true;
        this.agreementShow = false;
      },
      // 协议滚动监听
      agreementScrollHandler(e) {
        if ((e.target.offsetHeight + e.target.scrollTop) == e.target.scrollHeight) {
          this.agreementReaded = true;
        }
      },
      initSignPad() {
        this.signPadShow = true;
        this.$nextTick(() => {
          let canvas = document.getElementById('signaturePad');
          canvas.width = this.$refs.signBox.clientWidth;
          // 动态设置canvas高度，比例保持到1.818
          $(canvas).height(this.$refs.signBox.clientWidth / 1.8181818181);
          canvas.height = this.$refs.signBox.clientWidth / 1.8181818181;
          this.signPadCanvas = new SignaturePad(canvas);
          let ratio = Math.max(window.devicePixelRatio || 1, 1);
          canvas.width = canvas.offsetWidth * ratio;
          canvas.height = canvas.offsetHeight * ratio;
          canvas.getContext('2d').scale(ratio, ratio);

        })
      },
      clearSignPad() {
        this.signPadCanvas.clear();
      },
      saveSign() {
        if (this.signPadCanvas.isEmpty()) {
          this.$notify('请先绘制签名');
          return;
        }
        this.signBase64 = this.signPadCanvas.toDataURL();
        this.signPadShow = false;
      },
      submit() {
        if (!this.agreement) {
          this.agreementShow = true;
        } else {
          console.log(this.idBackFile, this.idFrontFile)
          if (!this.idBackFile || !this.idBackFile.path) {
            this.$notify('请上传身份证人像页照片')
            return;
          }
          if (!this.idFrontFile || !this.idFrontFile.path) {
            this.$notify('请上传身份证国徽页照片')
            return;
          }
          if (!this.signBase64) {
            this.$notify('请上传手写签章')
            return;
          }
          // 暂不校验执照职称
          // if(!this.licenseFile || !this.licenseFile.path) {
          //   this.$notify('请上传执业医师资格证书照片')
          //   return;
          // }
          // if(!this.jobTitleFile || !this.jobTitleFile.path) {
          //   this.$notify('请上传职称证书照片')
          //   return;
          // }
          this.submitting = true;
          let postData = {
            user_id: this.userInfo.user_id,
            card_front: this.idFrontFile.path,
            card_back: this.idBackFile.path,
            cert_img: (this.licenseFile && this.licenseFile.path) ? this.licenseFile.path : '',
            cert_img_other: (this.license2File && this.license2File.path) ? this.license2File.path : '',
            title_img: (this.jobTitleFile && this.jobTitleFile.path) ? this.jobTitleFile.path : '',
            cert_code: this.certNumber,
            title_code: this.titleNumber,
            prac_code: this.pracNumber,
            prac_img: (this.pracFile && this.pracFile.path) ? this.pracFile.path : '',
            prac_img_other: (this.prac2File && this.prac2File.path) ? this.prac2File.path : '',
            moulage_image: this.signBase64, //.split("base64,")[1]
          }
          if (this.$route.query.invite_id) {
            postData.invite_id = this.$route.query.invite_id;
          }
          console.log(postData);
          this.$root.post('/doctorAuth', postData).then(data => {
            this.submitting = false;
            if (data.status == 1) {
              // 更新状态
              this.userInfo.doc_status = 2;
              store.set('userInfo', this.userInfo);
              this.$store.commit('setUserInfo', this.userInfo);
              this.$router.push('/doctor/waitting');
            } else {
              this.$notify(data.msg);
            }
            console.log(data);
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/Entering/certification.vue